import { lazy } from "react";

// Keep page modules outside the initial app bundle; shared shell components stay eager.
export const WorldEditorPage = lazy(() =>
	import("./Components/World/WorldEditorPage.tsx").then((m) => ({ default: m.WorldEditorPage })),
);
export const Match = lazy(() =>
	import("./Components/Match/Match.tsx").then((m) => ({ default: m.Match })),
);
export const DeckBuilder = lazy(() =>
	import("./Components/DeckBuilder/DeckBuilder.tsx").then((m) => ({ default: m.DeckBuilder })),
);
export const CollectionShopPage = lazy(() =>
	import("./Components/Collection/CollectionShopPage.tsx").then((m) => ({
		default: m.CollectionShopPage,
	})),
);
export const CardBuilder = lazy(() =>
	import("./Components/CardBuilder/CardBuilder.tsx").then((m) => ({ default: m.CardBuilder })),
);
export const Dashboard = lazy(() =>
	import("./Components/Dashboard/Dashboard.tsx").then((m) => ({ default: m.Dashboard })),
);
export const GameManualPage = lazy(() =>
	import("./Components/GameManual/GameManualPage.tsx").then((m) => ({ default: m.GameManualPage })),
);
export const ActionHistoryPage = lazy(() =>
	import("./Components/ActionHistory/ActionHistoryPage.tsx").then((m) => ({
		default: m.ActionHistoryPage,
	})),
);
export const CampaignAdminPage = lazy(() =>
	import("./Components/Campaign/CampaignAdminPage.tsx").then((m) => ({
		default: m.CampaignAdminPage,
	})),
);
export const CampaignPreviewOpenPage = lazy(() =>
	import("./Components/Campaign/CampaignPreviewOpenPage.tsx").then((m) => ({
		default: m.CampaignPreviewOpenPage,
	})),
);
export const CampaignSelectionPage = lazy(() =>
	import("./Components/Campaign/CampaignSelectionPage.tsx").then((m) => ({
		default: m.CampaignSelectionPage,
	})),
);
export const MatchBotDashboardPage = lazy(() =>
	import("./Components/Match/Component/MatchBotDashboardPage.tsx").then((m) => ({
		default: m.MatchBotDashboardPage,
	})),
);
export const MatchCardInstancesPage = lazy(() =>
	import("./Components/Match/Component/MatchCardInstancesPage.tsx").then((m) => ({
		default: m.MatchCardInstancesPage,
	})),
);
export const ArtStylesPage = lazy(() =>
	import("./Components/ArtStyles/ArtStylesPage.tsx").then((m) => ({ default: m.ArtStylesPage })),
);
export const ConditionalGroupsPage = lazy(() =>
	import("./Components/ArtStyles/ArtStylesPage.tsx").then((m) => ({
		default: m.ConditionalGroupsPage,
	})),
);
export const AbilityFormulasPage = lazy(() =>
	import("./Components/AbilityFormulas/AbilityFormulasPage.tsx").then((m) => ({
		default: m.AbilityFormulasPage,
	})),
);
export const CardBackArtworkPage = lazy(() =>
	import("./Components/CardBacks/CardBackArtworkPage.tsx").then((m) => ({
		default: m.CardBackArtworkPage,
	})),
);
export const AdminUsersPage = lazy(() =>
	import("./Components/AdminUsers/AdminUsersPage.tsx").then((m) => ({ default: m.AdminUsersPage })),
);
export const BotPersonasPage = lazy(() =>
	import("./Components/BotPersonas/BotPersonasPage.tsx").then((m) => ({
		default: m.BotPersonasPage,
	})),
);
export const GameSettingsProfilesPage = lazy(() =>
	import("./Components/GameSettingsProfiles/GameSettingsProfilesPage.tsx").then((m) => ({
		default: m.GameSettingsProfilesPage,
	})),
);
export const TranslationsPage = lazy(() =>
	import("./Components/Translations/TranslationsPage.tsx").then((m) => ({
		default: m.TranslationsPage,
	})),
);
export const LogDashboardPage = lazy(() =>
	import("./Components/Logs/LogDashboardPage.tsx").then((m) => ({ default: m.LogDashboardPage })),
);
export const StyleGuidePages = lazy(() =>
	import("./Components/StyleGuide/StyleGuidePages.tsx").then((m) => ({
		default: m.StyleGuidePages,
	})),
);
export const ProfilePage = lazy(() =>
	import("./Components/Profile/ProfilePage.tsx").then((m) => ({ default: m.ProfilePage })),
);
export const PortraitAtelierPage = lazy(() =>
	import("./Components/Profile/PortraitAtelierPage.tsx").then((m) => ({
		default: m.PortraitAtelierPage,
	})),
);
export const FeedbackPage = lazy(() =>
	import("./Components/Feedback/FeedbackPage.tsx").then((m) => ({ default: m.FeedbackPage })),
);
export const SiteFeaturesAdminPage = lazy(() =>
	import("./Components/SiteFeatures/SiteFeaturesAdminPage.tsx").then((m) => ({
		default: m.SiteFeaturesAdminPage,
	})),
);
export const DesignAssetsPage = lazy(() =>
	import("./Components/DesignAssets/DesignAssetsPage.tsx").then((m) => ({
		default: m.DesignAssetsPage,
	})),
);
export const DesignAssetsHelpPage = lazy(() =>
	import("./Components/DesignAssets/DesignAssetsHelpPage.tsx").then((m) => ({
		default: m.DesignAssetsHelpPage,
	})),
);
export const DeveloperDashboardPage = lazy(() =>
	import("./Components/DeveloperDashboard/DeveloperDashboardPage.tsx").then((m) => ({
		default: m.DeveloperDashboardPage,
	})),
);
export const InvitationPage = lazy(() =>
	import("./Components/Social/InvitationPage.tsx").then((m) => ({ default: m.InvitationPage })),
);
export const WorldPlayer = lazy(() =>
	import("./Components/World/WorldPlayer.tsx").then((m) => ({ default: m.WorldPlayer })),
);
export const WorldGroupEntry = lazy(() =>
	import("./Components/World/WorldGroupEntry.tsx").then((m) => ({ default: m.WorldGroupEntry })),
);
export const FriendsPage = lazy(() =>
	import("./Components/Social/FriendsPage.tsx").then((m) => ({ default: m.FriendsPage })),
);
export const WorldSelectionPage = lazy(() =>
	import("./Components/World/WorldSelectionPage.tsx").then((m) => ({
		default: m.WorldSelectionPage,
	})),
);
